let language = {
    ADD_STORE_PRODUCT_MODAL_SETECT_PRODUCT_TYPE_TITLE:"选择商店产品类型",
    ADD_STORE_PRODUCT_MODAL_SETECT_PRODUCT_TYPE_BACK_BTN:"返回"
    };
    
    export { language }